import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { FileText, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

const FIELDS = [
  { key: "about_us", label: "About Us", rows: 5, ph: "Sootrik ke baare me likhein..." },
  { key: "terms", label: "Terms & Conditions", rows: 7, ph: "Terms & Conditions likhein..." },
  { key: "contact_us", label: "Contact Us", rows: 4, ph: "Mobile, Email, Address..." },
];

export const AdminSiteInfo = ({ adminKey }) => {
  const [info, setInfo] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/public/site-info").then((r) => setInfo(r.data)).catch(() => setInfo({ about_us: "", terms: "", contact_us: "", copyright_by: "" }));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const r = await api.put("/admin/site-info", info, { headers: { "X-Admin-Key": adminKey } });
      setInfo(r.data);
      toast.success("Website info save ho gaya");
    } catch (e) { toast.error(e?.response?.data?.detail || "Save nahi hua"); }
    setSaving(false);
  };

  if (!info) return null;

  return (
    <div className="bg-card border border-border rounded-xl p-4 shadow-sm space-y-3" data-testid="admin-site-info">
      <div>
        <p className="font-heading font-bold flex items-center gap-1.5"><FileText className="h-4 w-4 text-cyan-600" /> About Us, Terms & Contact Us</p>
        <p className="text-xs text-muted-foreground">Ye sab home page ke bottom (footer) me users ko dikhega.</p>
      </div>
      {FIELDS.map((f) => (
        <div key={f.key} className="space-y-1">
          <Label>{f.label}</Label>
          <Textarea rows={f.rows} value={info[f.key]} onChange={(e) => setInfo({ ...info, [f.key]: e.target.value })} placeholder={f.ph} data-testid={`admin-site-${f.key}`} />
        </div>
      ))}
      <div className="space-y-1 max-w-sm">
        <Label>Copyright Name (… All Rights Reserved by ___)</Label>
        <Input value={info.copyright_by} onChange={(e) => setInfo({ ...info, copyright_by: e.target.value })} placeholder="Sootrik" data-testid="admin-site-copyright_by" />
      </div>
      <Button size="sm" onClick={save} disabled={saving} className="gap-1.5 bg-cyan-600 hover:bg-cyan-700 text-white" data-testid="admin-site-save-btn">
        <Save className="h-4 w-4" /> {saving ? "Saving..." : "Save Website Info"}
      </Button>
    </div>
  );
};
